import { logUtil } from 'packages/src'
import { toLowerCaseStringUtil } from '@gymaholic/packages'

function formatEvent (str) {
  return toLowerCaseStringUtil(str)
    .replace(/ /g, '_')
    .replace(/\?/g, '')
}

/**
 * @param action
 * @param eventData
 * @param eventData.eventCategory
 * @param eventData.eventLabel
 * @param eventData.rest
 */
function logEventGoogleAnalyticsUtil (action, {
  eventCategory,
  eventLabel,
  ...rest
} = {}) {
  const data = {
    event_category: formatEvent(eventCategory),
    event_label: formatEvent(eventLabel),
    ...rest
  }

  action = formatEvent(action)
  const logPrefix = `action=${action}`

  logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix} data=`, data)
  if (!BROWSER) {
    logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix} [noop] not browser`)
    return
  }

  if (!PRODUCTION) {
    logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix} [noop] not production`)
    return
  }

  if (!window.gtag) {
    logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix}[noop] no gtag`)
    return
  }

  window.gtag('event', action, { ...data })
  logUtil('logEventGoogleAnalyticsUtil').debug(`${logPrefix} data=`, data)
}

export default logEventGoogleAnalyticsUtil
